import React from 'react';
import { prettyDate } from '../../utils/strings';
import { Space } from '../utils/utils';
import styles from './archive.module.scss';
import { IoCloudDownload } from 'react-icons/io5';
import { downloadActionDocument } from '../../network/measure';
import {
  downloadLitigationArchiveDocument,
  downloadLitigationDocument
} from '../../network/litigii';
import { types_TermPeriods } from '../../types/litigations';

const CArchive = (props: any) => {
  const { documents } = props;
  console.log(documents);

  return (
    <div className={styles.timeline}>
      {(!documents || documents.length === 0) && (
        <p className={`body-dark bold`}>
          Momentan nu există niciun document in arhivă.
        </p>
      )}
      {documents && documents.length > 0 && (
        <p className='subheading-dark bold'>Arhivă electronică</p>
      )}
      {documents && documents.length > 0 && <Space vertical='5vh' />}
      <div className={styles.grid}>
        {documents &&
          documents.map((document: any, index: number) => (
            <div className={styles.line} key={index}>
              <p>
                <span className='body-dark bold'>{document.name}</span>
                <br />
              </p>
              <div className='col'>
                <span className={styles.dot}>
                  <IoCloudDownload
                    onClick={() =>
                      downloadLitigationArchiveDocument(
                        document.id,
                        document.name
                      )
                    }
                  />
                </span>
              </div>
            </div>
          ))}
      </div>
      {documents && documents.length > 0 && <Space vertical='5vh' />}
    </div>
  );
};

export default CArchive;
